import React from 'react';
import { useLocation } from 'react-router-dom';
import { getLangFromPath } from '../i18n/lang';

import TermsPageUk from './static/TermsPage.uk.jsx';
import TermsPageEn from './static/TermsPage.en.jsx';
import TermsPageIt from './static/TermsPage.it.jsx';
import TermsPageFr from './static/TermsPage.fr.jsx';

export default function TermsPage() {
  const loc = useLocation();
  const lang = getLangFromPath(loc.pathname);
  const Map = { uk: TermsPageUk, en: TermsPageEn, it: TermsPageIt, fr: TermsPageFr };
  const L = Map[lang] || TermsPageUk;
  return <L />;
}
